import React, { Component } from 'react';
import { Toast } from 'antd-mobile';
// import { Link } from 'react-router-dom';
import Http from '../../config/axiosUtils';
// import Withdraw from '../Wallet/Withdraw';
import defaultFaceImg from '../../assets/images/idCard/face@2x.png';
import defaultBackImg from '../../assets/images/idCard/back@2x.png';
import right from '../../assets/images/idCard/right@2x.png'
import againUpLoad from '../../assets/images/idCard/file_btn@2x.png';
import '../../assets/scss/IDCard/IDCard.scss';
// import { handleFile } from '../../utils/util.exif';
import { isWeixin, isMQQbrowser, isAndroid, isQuark } from '../../utils/util.browser';
import { Helmet } from 'react-helmet';
import Notice from '../../components/notice/Notice';

class IDCard extends Component {

    constructor() {
        super();
        this.state = {
            showNotice : false,
            isDefaultImg: true,
            isComfirm: false,
            initData:{},
            frontImgUrl:"",
            backImgUrl:"",
            cardId:"",
            name:"",
            ocrResultId:"",
            img: {
                defaultFaceImg,
                defaultBackImg,
            },
            fileType:"image",
            firstFile: null,
            isFontOrBack:true,
            userBackImgInfo: null, // 身份证反面照信息
            userBackImgInfoKey: null, // 身份证反面照key
            userFrontImgInfo: null, // 身份证正面照信息
            userFrontImgInfoKey: null, // 身份证正面照key
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        const path = '/spread/web/spread/wallet/ocrInfo';
        const res = await Http.get(path);
        if (res.code === 0) {
            this.setState({
                initData: res.data,
                backImgUrl:res.data.backImgUrl,
                cardId:res.data.cardId,
                frontImgUrl:res.data.frontImgUrl,
                name:res.data.name,
                ocrResultId:res.data.ocrResultId,
            });
        } else {
            Toast.fail(res.msg, 2);
        }
    }

    setCapture() {
        const input = document.getElementById('file');
        //使用了什么内核：window.navigator.userAgent
        if (isAndroid() && isWeixin() && !isMQQbrowser()) {
            //强制添加摄像头调用功能
            input.capture = 'camera';
        } else {
            input.removeAttribute('capture');
        }
    }

    getFontFile = (e) =>  {
        const file = e.target.files[0];
        this.setState({
            firstFile : file,
            isFontOrBack:true,
        });
        if (!file.size) {return;}
        let errorMsg = null;
        if (this.state.fileType === 'image' && !/image\/\w+/.test(file.type)) {
            errorMsg = '请上传图片类型的文件';
        }
        if (errorMsg) {
            Toast.fail(errorMsg);
            document.querySelector('.idCard').value = null;
            return;
        }
        this.fetchUpload(file);
    }

    getBackFile = (e) =>  {
        const file = e.target.files[0];
        this.setState({
            firstFile : file,
            isFontOrBack:false,
        });
        if (!file.size) {return;}
        let errorMsg = null;
        if (this.state.fileType === 'image' && !/image\/\w+/.test(file.type)) {
            errorMsg = '请上传图片类型的文件';
        }
        if (errorMsg) {
            Toast.fail(errorMsg);
            document.querySelector('.idCard').value = null;
            return;
        }
        this.fetchUpload(file);
    }

    fetchUpload = async (file) => {
        Toast.loading("文件上传中，请稍等……",0);
        const formData = new FormData();
        if (isQuark()) { // 夸克浏览器上传原文件，否则后台接受文件size为0
            formData.append('file', this.state.firstFile);
        } else {
            formData.append('file', file);
        }
        const path = "/spread/web/common/uploadCardImage";
        const res = await Http.post(path, formData);
        if (res.code === 0) {
            Toast.hide();
            const uploadData = {
                file,
                absoluteUrl: res.data.absoluteUrl,
            };
            if (this.state.isFontOrBack) {
                this.setState({
                    userFrontImgInfo : uploadData,
                    userFrontImgInfoKey:res.data.url,
                    frontImgUrl:res.data.absoluteUrl,
                });
            } else  {
                this.setState({
                    userBackImgInfo : uploadData,
                    userBackImgInfoKey:res.data.url,
                    backImgUrl:res.data.absoluteUrl,
                });
            }
            if (this.state.userBackImgInfoKey && this.state.userFrontImgInfoKey) {
                this.ocrIDCard();
            }
        } else {
            Toast.hide();
        }
        this.refs.file.value = null;
    }

    ocrIDCard = async () => {
        const path = '/spread/web/spread/wallet/ocr/idCard';
        const postData = {
            frontImgUrl: this.state.userFrontImgInfoKey,
            backImgUrl: this.state.userBackImgInfoKey,
        }
        Toast.loading("信息识别中，请稍等……",0);
        const res = await Http.post(path,postData);
        if (res.code === 0) {
            Toast.hide();
            this.setState({
                name:res.data.name,
                cardId:res.data.cardId,
                ocrResultId:res.data.ocrResultId,
                isComfirm: true,
            });
        } else if (res.code === 1) {
            Toast.hide();
            if (res.data) {
                this.setState({
                    name:res.data.name,
                    cardId:res.data.cardId,
                    ocrResultId:res.data.ocrResultId,
                    isComfirm: false,
                });
            }
            Toast.fail(res.msg);
        } else  {
            Toast.hide();
            Toast.fail(res.msg);
            this.setState({
                isComfirm: false,
            });
        }
    }
    signSubmit = async () => {
        const path = '/spread/web/spread/wallet/ocr/idCard/' + this.state.ocrResultId;
        const res = await Http.get(path);
        if (res.code === 0) {
            Toast.success(res.msg,2);
        } else  {
            Toast.fail(res.msg, 2);
        }
    }

    fontFrontCard(isDefaultImg,frontImgUrl,img) {
        let fontFactCard;
        fontFactCard = (
            <div className={frontImgUrl ? "imgBorder": ""}>
                {
                    frontImgUrl ? <img src={right} className="rightBtn" alt='' /> :""
                }
                <img src={frontImgUrl || img.defaultFaceImg} className="photoImg" alt=''/>
                <img src={frontImgUrl ? againUpLoad : ""} className="fileBtn" alt=''/>
            </div>
        )
        return fontFactCard;
    }

    fontBackCard(isDefaultImg,backImgUrl,img) {
        let fontFactCard;
        fontFactCard = (
            <div className={backImgUrl ? "imgBorder": ""}>
                {
                    backImgUrl ? <img src={right} className="rightBtn"  alt=''/> :""
                }
                <img src={backImgUrl || img.defaultBackImg} className="photoImg" alt=''/>
                <img src={backImgUrl ? againUpLoad : ""} className="fileBtn" alt=''/>
            </div>
        )
        return fontFactCard;
    }

    render() {
        const { isDefaultImg,frontImgUrl,backImgUrl,img} = this.state;
        let fontFactCard = this.fontFrontCard(isDefaultImg,frontImgUrl,img);
        let fontBackCard = this.fontBackCard(isDefaultImg,backImgUrl,img);
        return (
            <div className="container">
                <Helmet><title>上传身份证</title></Helmet>
                <div className="applyGetPhoto">
                    <div className="content">
                        <div className="detail">
                            <div className="photo">
                                {fontFactCard}
                                <input name="idCard" type="file" ref="file" id="file" onChange={this.getFontFile} accept="image/*" className="cardId"/>
                            </div>
                            <div className="photo" onClick={this.judgeHasFront}>
                                {fontBackCard}
                                {this.state.frontImgUrl ? <input name="idCard" type="file" ref="file" id="file" onChange={this.getBackFile} accept="image/*" className="cardId"/> : null}
                            </div>
                            {(this.state.frontImgUrl || this.state.backImgUrl) ? <div className="tip" style={{textAlign:"left"}}>如信息有误可点击照片重新上传</div> : <div class="tip" onClick= {this.checkContent}>查看<span>拍摄须知 ></span></div>}
                        </div>
                        {this.state.name ? <div className="info borderTop">
                            <div className="label">姓名</div>
                            <div className="card">{this.state.name}</div>
                        </div> : null}
                        {this.state.cardId ? <div className="info">
                            <div className="label">身份证</div>
                            <div className="card">{this.state.cardId}</div>
                        </div> : null}
                    </div>
                    <div className="shoot">
                        <div className={this.state.cardId && this.state.isComfirm ? "btn" : "disable"} onClick={this.sureAction} >确认</div>
                    </div>
                    {this.state.showNotice ? <Notice closeNotice = {this.closeNotice}></Notice> : null}
                </div>
            </div>
        )
    }

    sureAction = async () => {
        if (this.state.cardId && this.state.isComfirm ) {
            const path = '/spread/web/spread/wallet/withdraw/sign';
            const res = await Http.post(path, {});
            if (res.code === 0) {
                window.history.back(-1);
            } else {
                Toast.fail(res.msg, 2);
            }
            
        }
    }

    closeNotice = () => {
        this.setState({
            showNotice:false,
        })
    }

    judgeHasFront = () => {
        if (!this.state.frontImgUrl) {
            Toast.info('请先上传身份证正面照', 2);
        }
    }

    checkContent = () => {
        this.setState({
            showNotice:true
        });
    }
}

export default IDCard;
